import objectKeysInternal from './object-keys-internal.js';
import enumBugKeys$1 from './enum-bug-keys.js';

var internalObjectKeys = objectKeysInternal;
var enumBugKeys = enumBugKeys$1; // `Object.keys` method
// https://tc39.es/ecma262/#sec-object.keys
// eslint-disable-next-line es/no-object-keys -- safe

var objectKeys = Object.keys || function keys(O) {
  return internalObjectKeys(O, enumBugKeys);
};

export { objectKeys as default };
